import Swiper from 'swiper'
import { TweenMax } from 'gsap'
import $ from 'jquery'

export default {
  init() {
    $( ".imagesSlider" ).each(function( index ) {
      const el = $(this)[0]
      const t = $(this)

      const lightbox = new Swiper(el.querySelector('.imagesSlider-lightbox-slider'), {
        loop: true,
        on: {
          slideChange: function() {
            $(el).find('.imagesSlider-currentSlide').text(this.realIndex + 1 < 10 ? `0${this.realIndex + 1}` : this.realIndex + 1)
            const barWidth = $(el).find('.imagesSlider-scrollBar').width()
            const nbSlides = $(el).find('.imagesSlider-lightbox .swiper-slide:not(.swiper-slide-duplicate)').length
            $(el).find('.imagesSlider-scrollBar-bar').css('margin-left', this.realIndex * (barWidth / nbSlides) + 'px')
          },
          init: function() {
            const barWidth = $(el).find('.imagesSlider-scrollBar').width()
            const nbSlides = $(el).find('.imagesSlider-lightbox .swiper-slide:not(.swiper-slide-duplicate)').length
            $(el).find('.imagesSlider-scrollBar-bar').css('width', barWidth / nbSlides + 'px')
          }
        },
      })

      const s = new Swiper(el.querySelector('.imagesSlider-slider'), {
        slidesPerView: 'auto',
        freeMode: false,
        spaceBetween: IS_MOBILE ? 10 : 20
      })

      let isLightboxOpen = false

      const openLightbox = () => {
        TweenMax.to($(this).find('.imagesSlider-lightbox'), .5, {
          autoAlpha: 1
        })

        isLightboxOpen = true
      }

      const closeLightbox = () => {
        TweenMax.to($(this).find('.imagesSlider-lightbox'), .5, {
          autoAlpha: 0
        })

        isLightboxOpen = false
      }

      $(this).find('.imagesSlider-nav-item--next').on('click', () => {
        s.slideNext()
      })

      $(this).find('.imagesSlider-nav-item--prev').on('click', () => {
        s.slidePrev()
      })

      $(this).find('.imagesSlider-lightbox-prev').on('click', () => {
        lightbox.slidePrev()
      })

      $(this).find('.imagesSlider-lightbox-next').on('click', () => {
        lightbox.slideNext()
      })

      $(this).find('.imagesSlider-slide').on('click', function () {
        lightbox.slideTo(parseInt($(this).attr('data-slide')), 0)
        openLightbox()
      })

      $(this).find('.imagesSlider-lightbox').on('click', () => {
        closeLightbox()
      })

      $(this).find('.imagesSlider-lightbox-closeBtn').on('click', () => {
        closeLightbox()
      })

      $(this).find('.imagesSlider-lightbox-nav-item').on('click', e => {
        e.stopPropagation()
      })

      $(this).find('.imagesSlider-pagination').on('click', e => {
        e.stopPropagation()
      })

      $(this).find('.imagesSlider-lightbox-slide img').on('click', e => {
        e.stopPropagation()
      })

      document.addEventListener('keydown', e => {
        if (isLightboxOpen) {
          if (e.keyCode === 27) {
            closeLightbox()
          }

          if (e.keyCode === 37) {
            lightbox.slidePrev()
          }

          if (e.keyCode === 39) {
            lightbox.slideNext()
          }
        }
      })
    })
  }
}
